/* eslint-disable @next/next/no-img-element */
import { renderClassName } from "@/utils/renderClassName";
import { getImageProps } from "next/image";
import React from "react";

type CustomImageProps = {
  src: string;
  srcTablet: string;
  srcMobile: string;
  alt: string;
  isImageFromCloudflare?: boolean;
  className?: string;
  isAbsolute?: boolean;
  isPriority?: boolean;
  isFull?: boolean;
  width?: string;
  height?: string;
};

const CustomImage = ({
  src,
  srcTablet,
  srcMobile,
  alt,
  isImageFromCloudflare,
  isAbsolute,
  className,
  isPriority,
  isFull = true,
  width,
  height,
}: CustomImageProps) => {
  const common = {
    alt: alt,
    width: width ? Number(width) : undefined,
    height: height ? Number(height) : undefined,
    priority: isPriority,
    fill: (width || height) && isFull ? false : true,
    sizes: "100vw",
    quality: 65,
    className: renderClassName(isAbsolute ? "" : "image", className),
  };
  const {
    props: { srcSet: desktop },
  } = getImageProps({
    ...common,
    src: src,
  });

  const {
    props: { srcSet: tablet },
  } = getImageProps({
    ...common,
    src: srcTablet,
  });

  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    src: srcMobile,
  });
  return (
    <picture className={renderClassName(isAbsolute ? "" : "image", className)}>
      <source
        media="(min-width: 1000px)"
        srcSet={isImageFromCloudflare ? src : desktop}
        sizes="100vw"
      />
      <source
        media="(min-width: 768px)"
        srcSet={isImageFromCloudflare ? srcTablet : tablet}
        sizes="100vw"
      />
      <source
        media="(min-width: 250px)"
        srcSet={isImageFromCloudflare ? srcMobile : mobile}
        sizes="100vw"
      />
      <img
        className={renderClassName(isAbsolute ? "" : "image", className)}
        src={srcMobile}
        width={width ? Number(width) : undefined}
        height={height ? Number(height) : undefined}
        alt={common.alt}
        sizes="100vw"
        loading={isPriority ? "eager" : "lazy"}
      />
    </picture>
  );
};

export default CustomImage;
